import React, {useState} from "react";
import DeleteIcon from "@material-ui/icons/Delete";


function ToDoItem(props) {
  const [ismarked,setMark] = useState(false);
  function markCheck() {
    setMark(prev => {
      return !prev;
    });
    
  }
  return (
    <div>
      <li >
        <span onClick = {markCheck}
        style = { {textDecoration : ismarked ? "line-through": "none"}}>
        {props.text}
        </span>
        <span onClick={() => {
        props.onChecked(props.id);
      }} 
      class= "delete">
      <DeleteIcon/>
      </span>
      </li>
    </div>
  );
}

export default ToDoItem;
